<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container">
    <a class="navbar-brand" href="#" style="margin-left: -60px;">
      <img [src]="imagelogoRoute" style="width: 170px; left: -125px;" class="logo_company" alt="logo_company"/>
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa-solid fa-bars menu"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item" *ngIf="this.rolName == 'Coordinador' || this.rolName == 'Funcionario'|| this.rolName == 'Subdirector' ">
          <a class="nav-link" href="sst">Inicio</a>
        </li>
        <li class="nav-item" *ngIf="this.rolName== 'Ciudadano'">
          <a class="nav-link" href="ciudadano/listado-solicitudes">Mis Trámites</a>
        </li>
        <li class="nav-item" *ngIf="this.rolName== 'Ciudadano'">
          <a class="nav-link" href="ciudadano/crear-solicitud">Registrar Trámite</a>
        </li>
        <li class="nav-item" *ngIf="this.rolName == 'Funcionario'">
          <a class="nav-link" href="validador/bandeja">Mis Trámites Pendientes</a>
        </li>
        <li class="nav-item" *ngIf="this.rolName == 'Coordinador'">
          <a class="nav-link" href="coordinador/bandeja">Mis Trámites Pendientes</a>
        </li>
        <li class="nav-item" *ngIf="this.rolName == 'Subdirector'">
          <a class="nav-link" href="director/bandeja">Mis Trámites Pendientes</a>
        </li>
        <li class="nav-item dropdown" *ngIf="this.rolName == 'Coordinador' || this.rolName == 'Funcionario'|| this.rolName == 'Subdirector' ">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Reportes
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a class="dropdown-item dir-menu-govco" href="reportes/dashboard">Dashboard</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/anulados">Trámites Anulados</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/devueltos">Trámites Devueltos</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/revocados">Trámites Revocados</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/licencias-generadas">Licencias Generadas</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/ministerio">Reporte Ministerio De Salud</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/reporte-por-cedula-SST">Consulta trámites LSST por No. de Identificación</a></li>
            <li><a class="dropdown-item dir-menu-govco" href="reportes/reporte-solicitudes">Solicitudes Trámites LSST</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</nav>


<div class="row">
  <div class="col-md-12 col-sm-12 col-lg-12 col-xxl-12">
    <div class="app_login">
      <a (click)="logout()" id="off" class="link-login-header-govco" *ngIf="loginDisplay">Cerrar sesión <span
        class="govco-sign-out-alt"></span></a>
      <a (click)="login()" id="off" class="link-login-header-govco" *ngIf="!loginDisplay"><span
        class="govco-sign-in-alt"></span> Iniciar sesión</a>
      <span id="username_log" *ngIf="loginDisplay" class="username-header-govco"> <img
        src="./assets/images/default_user.jpg" style="width: 20px;" alt="Logo_{{ userName }}"/> {{ userName }}</span>
    </div>
  </div>
</div>


